var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { extractModuleProp, isObject, BaseModel } from 'cerebral/internal';
import { observable, isObservable, isObservableMap, extendObservable, ObservableMap, } from 'mobx';
import { ComputedClass } from './Computed';
import { updateIn, traverse } from './utils';
import { CreateStateProvider } from './providers';
var Model = /** @class */ (function (_super) {
    __extends(Model, _super);
    function Model(controller) {
        var _this = _super.call(this, controller) || this;
        _this.state = extractModuleProp(controller.module, 'state', function (state, module) {
            return _this.observeState(state);
        });
        _this.StateProvider = function (devtools) {
            return CreateStateProvider(_this.state, devtools, _this, Model.useLegacyStateApi);
        };
        return _this;
    }
    // Used by initial state changed
    Model.prototype.set = function (path, value) {
        updateIn(this.state, path, function (parentState, key) {
            if (isObservableMap(parentState)) {
                parentState.set(key, value);
            }
            else {
                parentState[key] = value;
            }
        });
    };
    Model.prototype.toggle = function (path) {
        updateIn(this.state, path, function (parentState, key) {
            parentState[key] = !parentState[key];
        });
    };
    Model.prototype.push = function (path, value) {
        updateIn(this.state, path, function (parentState, key) {
            parentState[key].push(value);
        });
    };
    Model.prototype.merge = function (path, mergeValue) {
        var values = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            values[_i - 2] = arguments[_i];
        }
        var value = Object.assign.apply(Object, [mergeValue].concat(values));
        updateIn(this.state, path, function (parentState, key) {
            if (isObservableMap(parentState[key])) {
                parentState[key].merge(value);
            }
            else {
                Object.assign(parentState[key], value);
            }
        });
    };
    Model.prototype.pop = function (path) {
        updateIn(this.state, path, function (parentState, key) {
            parentState[key].pop();
        });
    };
    Model.prototype.shift = function (path) {
        updateIn(this.state, path, function (parentState, key) {
            parentState[key].shift();
        });
    };
    Model.prototype.unshift = function (path, value) {
        updateIn(this.state, path, function (parentState, key) {
            parentState[key].unshift(value);
        });
    };
    Model.prototype.splice = function (path) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        updateIn(this.state, path, function (parentState, key) {
            (_a = parentState[key]).splice.apply(_a, args);
            var _a;
        });
    };
    Model.prototype.unset = function (path) {
        var deleteKey = path.pop();
        updateIn(this.state, path, function (parentState, key) {
            parentState[key].delete(deleteKey);
        });
    };
    Model.prototype.concat = function (path, value) {
        updateIn(this.state, path, function (parentState, key) {
            parentState[key] = parentState[key].concat(value);
        });
    };
    Model.prototype.increment = function (path, delta) {
        if (delta === void 0) { delta = 1; }
        updateIn(this.state, path, function (parentState, key) {
            parentState[key] += delta;
        });
    };
    Model.prototype.get = function (path) {
        if (!path) {
            return this.state;
        }
        return path.reduce(function (currentState, key) {
            if (currentState === undefined) {
                return currentState;
            }
            if (currentState instanceof ObservableMap) {
                return currentState.get(key);
            }
            return currentState[key];
        }, this.state);
    };
    Model.prototype.observeState = function (state) {
        var _this = this;
        var root = observable({});
        var extension = traverse(state, function (parent, key, path) {
            if (isObservable(parent[key])) {
                return parent[key];
            }
            else if (isObject(parent[key])) {
                return observable(parent[key]);
            }
            return parent[key];
        });
        var extended = extendObservable(root, Object.keys(extension).reduce(function (root, key) {
            var propertyDescriptor = Object.getOwnPropertyDescriptor(extension, key);
            if (propertyDescriptor && 'get' in propertyDescriptor) {
                Object.defineProperty(root, key, propertyDescriptor);
            }
            else if (extension[key] instanceof ComputedClass) {
                extension[key].getState = function () { return ({
                    state: extended,
                    root: _this.state,
                }); };
                root[key] = extension[key];
            }
            else if (isObservable(extension[key])) {
                root[key] = observable.ref(extension[key]);
            }
            else {
                root[key] = extension[key];
            }
            return root;
        }, {}));
        return extended;
    };
    Model.useLegacyStateApi = false;
    return Model;
}(BaseModel));
export default Model;
//# sourceMappingURL=Model.js.map


//////////////////
// WEBPACK FOOTER
// /home/kryd0s/tmp/widgetbot/node_modules/@cerebral/fluent/es/Model.js
// module id = 149
// module chunks = 0